export const MDY_WIDGET_KINDS = Object.freeze(["text", "email", "password", "textarea", "number", "slider", "checkbox", "toggle", "radio", "segmented", "select", "multiselect", "datepicker", "daterange", "timepicker", "file", "colors"]);
/**
 * Carried by a popup that a renderer lifts out of its field and positions against the viewport,
 * alongside {@link MDY_POPUP_CLASS}. The container is the same either way; this only says the
 * coordinates are viewport coordinates, which is what a portalled popup needs and a projected one
 * that a panel positioned by its host, in its own coordinate space, must not have.
 */
export const MDY_OVERLAY_PORTAL_CLASS = "mdy-overlay";
